import axios, {AxiosResponse} from 'axios';
import { AccountsVM, KRADataVM } from '../Models/ViewModels';
import { GetUserLoginID } from './UserSessionManager';
const api_url = process.env.REACT_APP_STEM_API_BASE_URL+'/api'
const headers = { 
    'Accept': 'application/json',
    'Content-Type': 'application/json'
} 

export const KRAAdd = (KRAData:KRADataVM,loginId:any) =>{
  const payload= {"EmployeeID":loginId,"AccountName":KRAData.AccountName,
  "ProcessName":KRAData.ProcessName,"SubStateName":KRAData.SubStateName,
  "ProductionCount":KRAData.ProductionCount,"SubmittedOn":KRAData.SubmittedOn,"Remarks":KRAData.Remarks}
  return axios.post(api_url+'/KRAApproval/KraAdd',payload,{headers})
}

export const KRAEdit = (KRAData:KRADataVM,loginid:any,checkDesig:any) =>{
  const Submit=KRAData.SubmittedOn.split('/').reverse().join('/')
  const payload= {"AccountName":KRAData.AccountName,"ID":KRAData.KRAID,
  "ProcessName":KRAData.ProcessName,"SubStateName":KRAData.SubStateName,
  "ProductionCount":KRAData.ProductionCount,"SubmittedOn":Submit,"Remarks":KRAData.Remarks,"checkDesig":checkDesig,"loginid":loginid}
  return axios.post(api_url+'/KRAApproval/ApprovalEdit',payload,{headers})
 }

 export const GetKRAList=(loginId:string)=>{
   return axios.get(api_url+'/KRAApproval/GetKRAScreenDetail?empId='+loginId);
}

export const GetPRoductionCount=(loginId:string)=>{
  return axios.get(api_url+'/KRAApproval/GetKRAScreenDetail2?empId='+loginId);
}

export const GetProdCount=(loginId:string)=>{
  return axios.get(api_url+'/KRAApproval/GetKRAScreenDetail3?empId='+loginId);
}

export const GetAccountDetails=()=>{
    return axios.get(api_url+'/Account/GetAccountDetails');
}

export const EditAccount = (editAcc:AccountsVM,loginId:any) =>
   {
      const payload = { "AccountID" :  editAcc.AccountID,"AccountName":editAcc.AccountName,
      "AccountCode":editAcc.AccountCode,"VCAccountRefID":editAcc.VCAccountRefID,
      "ModifiedBy":loginId
   }
     return axios.post(api_url+'/Account/EditAccount',payload,{headers}) 
   }

   export const AddAccount = (AddAcc:AccountsVM,loginId:any) =>
   {
      const payload = { "AccountName":AddAcc.AccountName,
      "AccountCode":AddAcc.AccountCode,"VCAccountRefID":AddAcc.VCAccountRefID,"IsNonVC":AddAcc.IsNonVC,
      "CreatedBy":loginId
   }
     return axios.post(api_url+'/Account/AddAccount',payload,{headers})
   }
export const DeleteEmployeeScreenDetails=(KRAID:number)=>{ 
  return axios.post(api_url+'/KRAApproval/DeleteKRAScreenDetails?KRAID='+ KRAID)
  }

export const DeleteAccount=(AccountID:number)=>{
    return axios.post(api_url+'/Account/DeleteAccount?accountId='+ AccountID)
}